import apiClient from './client';

export const timelineApi = {
  /**
   * Get portfolio-wide timeline events.
   * @param {Object} params - Query parameters (company, fund, category, source, date_from, date_to, etc.)
   */
  getTimelineEvents: async (params = {}) => {
    const response = await apiClient.get('/api/v1/timeline/events', { params });
    return response.data;
  },

  /**
   * Get timeline events for a specific company.
   * @param {string} companyName - Company name (URL-encoded automatically)
   * @param {Object} params - Additional query parameters
   */
  getCompanyTimeline: async (companyName, params = {}) => {
    const response = await apiClient.get(
      `/api/v1/timeline/events/${encodeURIComponent(companyName)}`,
      { params }
    );
    return response.data;
  },

  /**
   * Get timeline aggregate statistics.
   * @param {Object} params - Query parameters (company optional)
   */
  getTimelineStats: async (params = {}) => {
    const response = await apiClient.get('/api/v1/timeline/stats', { params });
    return response.data;
  },

  /**
   * Update a GSheet-backed timeline event.
   * @param {string} eventId - Event ID (e.g. "public_123" or "internal_456")
   * @param {Object} updates - Fields to update: { status, gp_note, category, significance, sentiment }
   */
  updateTimelineEvent: async (eventId, updates) => {
    const response = await apiClient.patch(
      `/api/v1/timeline/events/${encodeURIComponent(eventId)}`,
      updates
    );
    return response.data;
  },
};
